import notify from 'devextreme/ui/notify';

export const notificacionSuccess = (texto) => {
    notify(texto, "success", 3000);
}

export const notificacionError = (texto) => {
    notify(texto, "error", 3000);
}

export const notificacionWarning = (texto) => {
    notify(texto, "warning", 3000);
}